import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useApp } from "@/context/AppContext";

export default function Products() {
  const [sp, setSp] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [q, setQ] = useState(sp.get("q") || "");
  const cat = sp.get("categoria") || "";
  const { t } = useApp();

  useEffect(() => { api.get("/categories").then((r) => setCategories(r.data)); }, []);

  useEffect(() => {
    const params = {};
    if (cat) params.category = cat;
    if (sp.get("q")) params.q = sp.get("q");
    api.get("/products", { params }).then((r) => setProducts(r.data));
  }, [cat, sp]);

  const setCategory = (c) => {
    const n = new URLSearchParams(sp);
    if (c) n.set("categoria", c); else n.delete("categoria");
    setSp(n);
  };

  const doSearch = (e) => {
    e.preventDefault();
    const n = new URLSearchParams(sp);
    if (q) n.set("q", q); else n.delete("q");
    setSp(n);
  };

  return (
    <div className="mx-auto max-w-7xl px-4 py-12">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-2">{t("products.eyebrow")}</div>
        <h1 className="text-4xl sm:text-5xl font-display font-bold">{t("products.title")}</h1>
      </div>

      <form onSubmit={doSearch} className="mb-6 flex gap-2 max-w-xl">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("products.search")} className="rounded-full" data-testid="search-input" />
        <Button type="submit" className="rounded-full btn-primary" data-testid="search-btn">{t("products.searchBtn")}</Button>
      </form>

      <div className="flex flex-wrap gap-2 mb-8">
        <button onClick={() => setCategory("")} data-testid="filter-all" className={`px-4 py-1.5 rounded-full text-sm border transition-colors ${!cat ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-muted"}`}>
          {t("products.all")}
        </button>
        {categories.map((c) => (
          <button key={c.id} onClick={() => setCategory(c.slug)} data-testid={`filter-${c.slug}`} className={`px-4 py-1.5 rounded-full text-sm border transition-colors ${cat === c.slug ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-muted"}`}>
            {c.name}
          </button>
        ))}
      </div>

      {products.length === 0 ? (
        <div className="text-center py-20 text-muted-foreground">{t("products.none")}</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
